import { Layout } from 'components/Layout/Layout';
import { LiveBetting as LiveBettingDesktop } from 'components/LiveBetting/LiveBetting';
import { LiveBetting as LiveBettingMobile } from 'components/mobile/LiveBetting/LiveBetting';
import { MobileLayout } from 'components/mobile/MobileLayout/MobileLayout';
import { useBreakpoint } from 'hooks/useBreakpoint';
export const LiveBetting = () => {
  const { isMobile } = useBreakpoint();
  return (
    <>
      {isMobile ? (
        <MobileLayout>
          <LiveBettingMobile />
        </MobileLayout>
      ) : (
        <Layout whiteBg>
          <LiveBettingDesktop />
        </Layout>
      )}
    </>
  );
};
